import { isServer } from '@mr-yum/frontend-core/dist/support/env'
import {
  Button,
  Divider,
  ListItem,
  ListItemContent,
  StarOutlineIcon,
} from '@mr-yum/frontend-ui'
import { getMembershipUrl } from 'components/LoyaltyMembership/utils'
import { AuraMemberShipCookie } from 'components/Rewards/hooks/useAuraOAuth'
import Cookies from 'js-cookie'
import { useLoyaltyDetailsQuery } from 'lib/gql'
import { formatPoints } from 'lib/utils'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

interface Props {
  venueSlug: string
  venueId?: string
  guestId: string
}

export const LoyaltyCTA = ({ venueSlug, venueId, guestId }: Props) => {
  const intl = useIntl()

  const [{ data, fetching }] = useLoyaltyDetailsQuery({
    variables: {
      venueSlug,
      externalMemberId:
        Cookies.get(AuraMemberShipCookie + '-' + venueSlug) || null,
    },
    pause: isServer,
  })

  const loyaltyDetails = data?.loyaltyDetails
  const metadata = loyaltyDetails?.metadata
  const membershipUrl = getMembershipUrl({
    infoLink: metadata?.infoLink,
    guestId,
    venueId,
    venueSlug,
  })

  const isLoading = fetching
  const hasNoLoyaltyDetails = !loyaltyDetails
  const isNotOptedIn = !loyaltyDetails?.guestData?.isOptedIn
  const hasNoPoints = !(
    loyaltyDetails?.guestData?.points && loyaltyDetails.guestData.points > 0
  )
  const isProgramNameTriton = metadata?.programName === 'Triton'
  const isProgramNameAura = metadata?.programName === 'Aura'

  if (
    isLoading ||
    hasNoLoyaltyDetails ||
    isNotOptedIn ||
    hasNoPoints ||
    isProgramNameTriton ||
    isProgramNameAura
  ) {
    return null
  }

  const anchorProps = {
    href: membershipUrl ? membershipUrl.toString() : '',
    target: '_blank',
    rel: 'noopener noreferrer',
  }

  return (
    <div>
      <ListItem data-testid="loyalty-cta" size="lg">
        <ListItemContent
          label={
            <div className="space-between flex items-center gap-4 my-body-md">
              <p className="grow">
                {formatPoints(loyaltyDetails?.guestData?.points)}{' '}
                {metadata?.pointName ||
                  intl.formatMessage({
                    defaultMessage: 'points',
                    id: 'KYUOY2',
                  })}
              </p>
              {membershipUrl && (
                <div data-testid="loyalty-learn-more">
                  <Button variant="secondary" size="sm" as="a" {...anchorProps}>
                    <FormattedMessage id="TdTXXf" defaultMessage="Learn more" />
                  </Button>
                </div>
              )}
            </div>
          }
          size="lg"
          leftIcon={<StarOutlineIcon />}
        />
      </ListItem>
      <Divider />
    </div>
  )
}
